import db from 'database';
import Helpers, { findEarliestAvailableID } from 'shared/helpers';
import moment from 'moment';

export default class Fase {
  _id;
  nome;
  createdAt;
  updatedAt;
  deletedAt;

  /**
   *
   * @param {Object} data
   * @param {Number} data.id
   * @param {String} data.nome
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  async save() {
    const curb = await db.fases.filter(x => String(x.id) === String(this.id));
    await curb.delete();
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    this._id = await findEarliestAvailableID(db, 'fases');
    return db.fases.put(this);
  }

  static describe = () => '++_id, nome, createdAt, updatedAt, deletedAt';
}
